export enum ETipoEtiqueta {
  EtiquetaMateriaPrima = 1,
  EtiquetaIdentificacaoProducao = 2,
  EtiquetaGarantia = 3,
  EtiquetaExpedicaoProduto = 4,
  EtiquetaExpedicaoPallet = 5,
  EtiquetaContainer = 6,
  EtiquetaCaixaEnvase = 7,
  EtiquetaIdentificacaoProducaoPA = 8,
}
